import { IntlShape } from 'react-intl';

const NewsletterBlockSchema = (intl: IntlShape) => ({
  title: intl.formatMessage({ id: 'Newsletter' }),
  required: [],
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['cleverreachUrl'],
    },
  ],
  properties: {
    cleverreachUrl: {
      title: intl.formatMessage({ id: 'Link' }),
      description: intl.formatMessage({
        id: 'Link to CleverReach form',
      }),
      widget: 'text',
    },
  },
});

export default NewsletterBlockSchema;
